import StepBucket from "pattern/StepBucket.js";
import {findStep} from './utils.js';

export const delay = (group, stepBuckets, delayAmount) => {
    let steps = [...group.steps];
    steps.reverse();
    let originalStepBuckets = [... stepBuckets];
    
    
    for (let step of steps) {
        let {stepNumber, position} = findStep(originalStepBuckets, step);
        let newStepNumber = Math.round((stepNumber + delayAmount) % stepBuckets.length);
        if (!originalStepBuckets[stepNumber]) {
            continue;
        }
        let stepsAtStepBucket = originalStepBuckets[stepNumber].steps;
        let track = stepBuckets[stepNumber].track;

        // delete the step
        stepBuckets[stepNumber]= new StepBucket(track);

        // add the step back at new step number (effectively moving it over by the
        // delay amount)
        stepBuckets[newStepNumber] = new StepBucket(track);
        stepBuckets[newStepNumber].steps = stepsAtStepBucket;
    }
    return stepBuckets;
};

